import React, { useState, useEffect } from "react";
import { useNavigate, Link, useSearchParams, useLocation } from "react-router-dom";

import iconHubsales from '../assets/icon-hubsales.png'
import './styles.css'
import { entrar, mensagemDe, situacaoDoEmail } from '../services/motor';

import WithAuth from '../services/withAuth'

/**
 * 🔗 PARA ONDE VOLTAR depois de entrar (16/09). Só caminho INTERNO: começa com uma
 * barra e não com duas (`//site` é outro domínio) nem com "/\\", e não é a
 * própria entrada — senão a nossa entrada viraria trampolim para mandar o cliente
 * para fora. Sem destino válido, fica o de sempre: o formulário de chamado.
 */
function destinoSeguro(de) {
    if (typeof de !== "string" || !de.startsWith("/") || de.startsWith("//") || de.startsWith("/\\")) return "/forms";
    if (de.startsWith("/authenticate")) return "/forms";
    return de;
}

/**
 * A PORTA DO CLIENTE: usuário e senha PRÓPRIOS (nível 1, 04/09/2026).
 *
 * Até 04/09 esta tela pedia e-mail e senha, ignorava a senha (EXIGIR_SENHA=0)
 * e validava o e-mail na base de contatos DA OCTADESK; "Esqueceu a senha?" e
 * "Cadastre-se" mandavam para o login deles. O chamado já nasce no nosso motor
 * e o cliente foi avisado de que cria usuário e senha para abrir chamado.
 *
 * O login é o MESMO do Radar (`/auth/login` do backoffice): quando a loja
 * passar a ter Radar, o gestor promove este mesmo usuário — mesma senha, sem
 * recriar nada. Aqui ele só vê o que ele mesmo abriu.
 */
function Login() {
    const navigate = useNavigate()
    const location = useLocation()
    const [params] = useSearchParams();
    useEffect(() => {
        document.title = "HubsAI | Portal de Atendimento";
    }, []);

    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const [aviso, setAviso] = useState(params.get("expirou") ? "Sua sessão expirou. Entre de novo." : (params.get("ok") || ""));
    const [enviando, setEnviando] = useState(false);

    async function submeter(e) {
        e.preventDefault();
        const limpo = String(email || "").trim().toLowerCase();
        if (/@(hubsai|hubsales)\.com\.br$/.test(limpo)) {
            setAviso("E-mail da equipe: entre pelo portal interno (portal.hubsai.com.br).");
            return;
        }
        setEnviando(true);
        try {
            const { token, usuario } = await entrar(limpo, senha);
            sessionStorage.setItem("token", token);
            sessionStorage.setItem("email", limpo);
            sessionStorage.setItem("nome", (usuario && usuario.nome) || limpo.split("@")[0]);
            sessionStorage.setItem("org", "");
            sessionStorage.setItem("idOrg", "");
            sessionStorage.setItem("idRequester", "");
            navigate(destinoSeguro(location.state && location.state.de), { replace: true });
        } catch (err) {
            // A ORIENTAÇÃO (05/09): em vez de "e-mail ou senha inválidos", dizer o
            // que fazer — não encontrado → cadastre-se; já na base ou já abriu
            // chamado, mas sem senha → "Esqueci a senha" cria a senha.
            const codigo = err && err.response && err.response.data && err.response.data.error;
            if (codigo === 'PASSWORD_NOT_SET') {
                setAviso("Seu e-mail já está na nossa base, mas ainda não tem senha. Clique em \"Esqueci a senha\" para cadastrar uma senha.");
            } else if (codigo === 'INVALID_CREDENTIALS') {
                try {
                    const s = await situacaoDoEmail(limpo);
                    if (s === 'nao_encontrado') setAviso("E-mail não encontrado. Clique em \"Criar conta\" para fazer o cadastro.");
                    else if (s === 'sem_senha') setAviso("Seu e-mail já abriu chamados conosco, mas ainda não tem senha. Clique em \"Esqueci a senha\" para cadastrar uma senha.");
                    else setAviso("Senha incorreta. Se não lembra, clique em \"Esqueci a senha\".");
                } catch (e2) {
                    setAviso(mensagemDe(e2, "Não consegui entrar. Confira e-mail e senha."));
                }
            } else {
                setAviso(mensagemDe(err, "Não consegui entrar. Confira e-mail e senha."));
            }
        } finally {
            setEnviando(false);
        }
    }

    return (
        <div className="container">
            <div className="container-login">
                <div className="wrap-login">
                    <form className="login-form" onSubmit={submeter}>

                        <span className="login-form-title">
                            <img src={iconHubsales} alt="HubsAI" />
                        </span>

                        <span className="login-form-title">Entre para abrir e acompanhar os seus chamados.</span>

                        <div className="container-login-form-btn">
                            <span style={{ fontSize: 12.5, color: '#6b7280', textAlign: 'center', lineHeight: 1.5 }}>
                                Por segurança, o Portal de Atendimento passou a exigir senha.
                                Se você já abria chamados com este e-mail, clique em "Esqueci a senha" e crie a sua.
                            </span>
                        </div>

                        <div className="wrap-input">
                            <input
                                className={email !== "" ? 'has-val input' : 'input'}
                                type="email"
                                value={email}
                                required
                                autoFocus
                                autoComplete="username"
                                onChange={event => setEmail(event.target.value)}
                            />
                            <span className="focus-input" data-placeholder="Email"></span>
                        </div>
                        <div className="wrap-input">
                            <input
                                className={senha !== "" ? 'has-val input' : 'input'}
                                type="password"
                                value={senha}
                                required
                                autoComplete="current-password"
                                onChange={event => setSenha(event.target.value)}
                            />
                            <span className="focus-input" data-placeholder="Senha"></span>
                        </div>
                        <div className="container-login-form-btn">
                            <button disabled={enviando} className={senha !== "" && email !== "" ? "login-form-btn2" : "login-form-btn"} >{enviando ? "Entrando…" : "Entrar"}</button>
                        </div>

                        {aviso && <div className="container-login-form-btn"><span style={{ color: '#7c3aed', textAlign: 'center' }}>{aviso}</span></div>}

                        <div className="container-login-form-btn">
                            <Link className='ticket' to='/esqueci'>Esqueci a senha</Link>
                        </div>
                        <div className="container-login-form-btn">
                            <span>Primeira vez aqui?</span>
                            <Link className='ticket' to='/criar-conta'> Criar conta</Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default WithAuth(Login);
